import { configureStore } from '@reduxjs/toolkit'

import { configReducer } from './configuration'
import { authReducer } from './authentication'
import { ferryContentReducer } from './ferryContent'
import { itinerariesReducer } from './itineraries'
import { accommodationContentReducer } from './accommodationContent'
import { userVehiclesReducer } from './userVehicles'
import { myRewardsReducer } from './myRewards'
import { myTravelCardsReducer } from './myTravelCards'
import { purchaseReducer } from './purchase'
import { cartReducer } from './cart'

export const store = configureStore({
  reducer: {
    accommodationContent: accommodationContentReducer,
    configuration: configReducer,
    ferryContent: ferryContentReducer,
    itineraries: itinerariesReducer,
    userData: authReducer,
    userVehicles: userVehiclesReducer,
    cart: cartReducer,
    myRewards: myRewardsReducer,
    myTravelCards: myTravelCardsReducer,
    purchase: purchaseReducer,
  },
})
